import { render } from "./OrderList.vue?vue&type=template&id=1798a353&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=1798a353&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1798a353"]])

export default __exports__